import { render, staticRenderFns } from "./EspeciesImage.vue?vue&type=template&id=7f4a46dc&"
import script from "./EspeciesImage.vue?vue&type=script&lang=js&"
export * from "./EspeciesImage.vue?vue&type=script&lang=js&"
import style0 from "./EspeciesImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports